/**
 * Generates an array of star rating items with unique stable keys.
 * @param {number} maxStars
 * @param {number} filledCount
 * @returns {{ id: string, isFilled: boolean }[]}
 */
export const generateStarRatingList = (maxStars = 5, filledCount = 5) => {
  const stars = [];
  for (let i = 1; i <= maxStars; i += 1) {
    stars.push({
      id: `star-${i}`,
      isFilled: i <= filledCount,
    });
  }
  return stars;
};

/**
 * Combines author name and company name into a bullet/dot separated string.
 * @param {string} name
 * @param {string} company
 * @param {string} separator
 * @returns {string}
 */
export const formatAuthorTitle = (name, company, separator = " · ") => {
  if (name && company) {
    return `${name}${separator}${company}`;
  }
  return name || company || "";
};

/**
 * Combines role and subtitle into a bullet/dot separated string.
 * @param {string} role
 * @param {string} subtitle
 * @param {string} separator
 * @returns {string}
 */
export const formatAuthorRoleSubtitle = (role, subtitle, separator = " • ") => {
  if (role && subtitle) {
    return `${role}${separator}${subtitle}`;
  }
  return role || subtitle || "";
};
